function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import fetch from 'cross-fetch';
import { useEffect } from 'react';
import { getCLS, getFID, getLCP, getFCP, getTTFB } from 'web-vitals';
import { useNetworkStatus, useHardwareConcurrency, useMemoryStatus } from 'react-adaptive-hooks';
import useEvent from './use-event';

var noOp = function noOp() {};

var webVitalsBase = {
  age: 0,
  type: 'web-vitals',
  url: 'current-page-url'
};
var vitals = {
  cls: null,
  fid: null,
  lcp: null,
  fcp: null,
  ttfb: null
};
var deviceMetrics = {
  device_mem: null,
  device_cpu: null,
  device_effective_connection: null
};

var updateWebVitals = function updateWebVitals(_ref) {
  var name = _ref.name,
      value = _ref.value;
  var vitalName = name.toLowerCase();
  vitals[vitalName] = value;
};

var updateDeviceMetrics = function updateDeviceMetrics(_ref2) {
  var deviceMemory = _ref2.deviceMemory,
      numberOfLogicalProcessors = _ref2.numberOfLogicalProcessors,
      effectiveConnectionType = _ref2.effectiveConnectionType;
  deviceMetrics.device_mem = deviceMemory;
  deviceMetrics.device_cpu = numberOfLogicalProcessors;
  deviceMetrics.device_effective_connection = effectiveConnectionType;
};

var setCurrentUrl = function setCurrentUrl() {
  webVitalsBase.url = window.location.href;
};

var appendReportParams = function appendReportParams(reportingEndpoint, reportParams) {
  var url = new URL(reportingEndpoint);
  var reportParamKeys = Object.keys(reportParams);
  var paramsString = reportParamKeys.map(function (param) {
    return "".concat(param, "=").concat(reportParams[param]);
  }).join('&');
  return url.search ? "".concat(reportingEndpoint, "&").concat(paramsString) : "".concat(reportingEndpoint, "?").concat(paramsString);
};

var sendBeacon = function sendBeacon(rawBeacon, reportingEndpoint, reportParams) {
  var beacon = JSON.stringify(rawBeacon);
  var beaconTarget = reportParams ? appendReportParams(reportingEndpoint, reportParams) : reportingEndpoint;

  if (navigator.sendBeacon) {
    var headers = {
      type: 'application/reports+json'
    };
    var blob = new Blob([beacon], headers);
    return new Promise(function (resolve, reject) {
      var beaconResult = navigator.sendBeacon(beaconTarget, blob);
      if (!beaconResult) reject(new Error('Send Beacon failed'));
      resolve();
    });
  }

  return fetch(beaconTarget, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/reports+json'
    },
    body: beacon,
    mode: 'no-cors'
  });
};

var shouldSample = function shouldSample(sampleRate) {
  var randomNumber = Math.floor(Math.random() * 100);
  return randomNumber <= sampleRate;
};

var useWebVitals = function useWebVitals(_ref3) {
  var enabled = _ref3.enabled,
      reportingEndpoint = _ref3.reportingEndpoint,
      _ref3$loggerCallback = _ref3.loggerCallback,
      loggerCallback = _ref3$loggerCallback === void 0 ? noOp : _ref3$loggerCallback,
      _ref3$sampleRate = _ref3.sampleRate,
      sampleRate = _ref3$sampleRate === void 0 ? 100 : _ref3$sampleRate,
      reportParams = _ref3.reportParams;
  var pageLoadTime;
  var shouldSendVitals = enabled && shouldSample(sampleRate);

  var _useNetworkStatus = useNetworkStatus(),
      effectiveConnectionType = _useNetworkStatus.effectiveConnectionType;

  var _useHardwareConcurren = useHardwareConcurrency(),
      numberOfLogicalProcessors = _useHardwareConcurren.numberOfLogicalProcessors;

  var _useMemoryStatus = useMemoryStatus(),
      deviceMemory = _useMemoryStatus.deviceMemory;

  var sendVitals = function sendVitals() {
    var pageExitTime = Date.now();
    var pageAge = pageExitTime - pageLoadTime;
    var beacon = [_objectSpread(_objectSpread({}, webVitalsBase), {}, {
      age: pageAge,
      body: _objectSpread(_objectSpread({}, vitals), deviceMetrics)
    })];
    sendBeacon(beacon, reportingEndpoint, reportParams).catch(loggerCallback);
  };

  useEvent('pagehide', shouldSendVitals ? sendVitals : noOp);
  useEffect(function () {
    pageLoadTime = Date.now();
    setCurrentUrl();
    updateDeviceMetrics({
      effectiveConnectionType: effectiveConnectionType,
      numberOfLogicalProcessors: numberOfLogicalProcessors,
      deviceMemory: deviceMemory
    });
    getCLS(updateWebVitals);
    getFID(updateWebVitals);
    getLCP(updateWebVitals);
    getFCP(updateWebVitals);
    getTTFB(updateWebVitals);
  }, []);
  return null;
};

export default useWebVitals;